module.exports = __webpack_public_path__ + "img/MG.c451b83f.svg";